import { Link } from 'react-router-dom';
import { PATH_DASHBOARD } from 'src/constants/spa-routes';
import React from 'react';

export const LinkToKnowledgeBase = ({
  isProjectActive = false,
  isInactivePlan = false,
  knowledgeBaseId,
}) => {
  return (
    <button
      disabled={!isProjectActive || isInactivePlan}
      className="[&_svg]:hover:opacity-100 [&_svg]:opacity-40 [&_svg]:transition [&_svg>path]:transition duration-300"
    >
      <Link
        onClick={(e) => {
          if (!isProjectActive || isInactivePlan) {
            e.preventDefault();
          }
        }}
        to={`${PATH_DASHBOARD.AI_KNOWLEDGE_BASE}/${knowledgeBaseId}`}
      >
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.7"
            d="M15.4444 16.4444H4.55556V5.55556H10V4H3V18H17V11H15.4444V16.4444ZM11.5556 4V5.55556H14.3478L6.70222 13.2011L7.79889 14.2978L15.4444 6.65222V9.44444H17V4H11.5556Z"
            fill="#05050D"
            stroke="#05050D"
            strokeWidth="0.2"
          />
        </svg>
      </Link>
    </button>
  );
};
